import React from 'react';
import { Content, Header, InfoGroup, Title, Wrapper } from './order-list-item.styles';
import { OrderListItemProps } from './types';
import { Tag } from '@shared/ui/tag/tag';
import { STATUS_MAP } from '../../config/ui-constants';
import { orderUsersCount } from '@entities/order/libs/utils/order-users-count/order-users-count';
import { userName } from '@shared/lib/utils/user-name/user-name';
import { dateStart } from '@shared/lib/utils/date/date';
import { Typography } from '@shared/ui/typography/typography';
import { EntityRelatedUser } from '@shared/ui/entity-related-user/entity-related-user';

export const OrderListItem: React.FC<OrderListItemProps> = ({ order, onClick }) => {
    const { orderUsersLength, orderUsers } = orderUsersCount(order);

    const isOneUser = orderUsersLength === 1;
    const firstUser = orderUsers[0];

    const manager = order?.company?.manager;

    const managerName = userName({
        firstName: manager?.firstName,
        lastName: manager?.lastName,
        middleName: manager?.middleName,
    });

    return (
        <Wrapper onClick={() => onClick(order.id)}>
            <Header>
                <Title size='subtitle2' color='neutral_90'>
                    {order.product.name}
                </Title>
            </Header>
            <Content>
                <InfoGroup $maxWidth={82}>
                    <Typography size='body2_long' color='neutral_50'>
                        ID сделки
                    </Typography>
                    <Typography size='body2_long'>{`№${order.id}`}</Typography>
                </InfoGroup>
                <InfoGroup $maxWidth={338}>
                    <Typography size='body2_long' color='neutral_50'>
                        Организация
                    </Typography>
                    <Typography size='body2_long'>{order.company?.shortName}</Typography>
                </InfoGroup>
                <InfoGroup $maxWidth={120}>
                    <Typography size='body2_long' color='neutral_50'>
                        Дата
                    </Typography>
                    <Typography size='body2_long'>{dateStart(order.createdAt)}</Typography>
                </InfoGroup>
                <InfoGroup $maxWidth={220}>
                    <Typography size='body2_long' color='neutral_50'>
                        Инициатор
                    </Typography>
                    {isOneUser ? (
                        <EntityRelatedUser user={firstUser} nameType='short' />
                    ) : (
                        <EntityRelatedUser count={String(orderUsersLength)} />
                    )}
                </InfoGroup>
                <InfoGroup $maxWidth={220}>
                    <Typography size='body2_long' color='neutral_50'>
                        Менеджер
                    </Typography>
                    <EntityRelatedUser user={manager} nameType='short' />
                </InfoGroup>
                <InfoGroup $maxWidth={164}>
                    <Typography size='body2_long' color='neutral_50'>
                        Статус
                    </Typography>
                    <Tag
                        variant={STATUS_MAP[order.status]?.variant}
                        declineMessage={
                            {
                                managerAvatarUrl: manager?.photoUrl || '',
                                managerName: managerName.full,
                                message: order.comment || '',
                            } || undefined
                        }>
                        {STATUS_MAP[order.status]?.children}
                    </Tag>
                </InfoGroup>
            </Content>
        </Wrapper>
    );
};
